import type { Jast, Clause } from '@atlaskit/jql-ast';
import { substring } from './common';
import { getClausePosition } from './get-clause-position';

/**
 * This replaces a clause in the AST with the given JQL.
 * Replacement JQL is passed as a function and value seperately to allow for value sanitization
 *
 * unsanitizedKeywordOrWords that are string[] are automatically wrapped in ()
 * @returns JQL
 */
export const replaceClause = (
	ast: Jast,
	clause: Clause,
	replacementJqlWithValue: (unsanitizedKeyword: string) => string,
	unsanitizedKeywordOrWords: string | string[],
) => {
	const currentJql = ast.represents;

	const santizedValue = Array.isArray(unsanitizedKeywordOrWords)
		? `(${unsanitizedKeywordOrWords.join(',')})`
		: unsanitizedKeywordOrWords;

	const position = getClausePosition(currentJql, clause);

	if (position) {
		const [start, end] = position;
		return `${substring(currentJql, 0, start)}${replacementJqlWithValue(
			santizedValue,
		)}${substring(currentJql, end)}`;
	}
	return currentJql;
};
